import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth0 } from '@auth0/auth0-react';
import { useSession } from '../lib/session';
export default function CreateAccountPage() {
  const { t } = useTranslation();
  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const trial = useSession(state => state.state);
  const [error, setError] = useState(false);
  const authenticate = async (signup: boolean) => {
    setError(false);
    try {
      await loginWithRedirect({
        authorizationParams: {
          redirect_uri: window.location.origin + '/auth/callback',
          ...(signup
            ? {
                screen_hint: 'signup',
                connection:
                  import.meta.env.VITE_AUTH0_DATABASE_CONNECTION ||
                  'Username-Password-Authentication',
              }
            : {}),
        },
      });
    } catch {
      setError(true);
    }
  };
  return (
    <main className="app-main">
      <section
        className="app-main-inner"
        style={{ maxWidth: 720, padding: '64px 24px' }}
      >
        <h1>
          {t(
            trial?.principalKind === 'anonymous' &&
              trial.limit > 0 &&
              trial.exhausted
              ? 'trial.complete'
              : 'trial.createTitle',
            {
              limit:
                trial?.principalKind === 'anonymous' ? trial.limit : undefined,
            }
          )}
        </h1>
        <p>{t('trial.invitation')}</p>
        <ul>
          {['saved', 'workspace', 'unlimited'].map(key => (
            <li key={key}>{t(`trial.benefits.${key}`)}</li>
          ))}
        </ul>
        {error && <p role="alert">{t('trial.authError')}</p>}
        {isAuthenticated ? (
          <Link className="button" to="/history">
            {t('nav.history')}
          </Link>
        ) : (
          <>
            <button className="button" onClick={() => void authenticate(true)}>
              {t('trial.createAccount')}
            </button>
            <p>{t('trial.noCard')}</p>
            <button
              className="button button-secondary"
              onClick={() => void authenticate(false)}
            >
              {t('trial.signIn')}
            </button>
          </>
        )}
        <p>
          <Link to="/history">{t('trial.returnToWork')}</Link>
        </p>
      </section>
    </main>
  );
}
